import React, { useEffect, useState } from "react";

import { proxy } from './../process/api';
import { useParams } from 'react-router-dom';
import DropDownControl from "./DropDownControl";
import BrandedLoader from "./BrandedLoader";

import ProcessLoader from "./ProcessLoader";
const UserPermissions = () => {


    const { uid, name, type } = useParams();
    const [pageTitle, setPageTitle] = useState('');
    const [showProcessLoader, setShowProcessLoader] = useState(true);
    const [showResetProcess, setshowResetProcess] = useState(false);
    const [userList, setUserList] = useState({});
    const [divMaster, setDivMaster] = useState({});
    const [divLoader, setDivLoader] = useState(true);
    const [divStatus, setDivStatus] = useState({});
    const [divChanged, setDivChanges] = useState({});

    const [depoMaster, setDepoMaster] = useState({});
    const [depoLoader, setDepoLoader] = useState(true);
    const [depoStatus, setDepoStatus] = useState({});
    const [depoChanged, setDepoChanges] = useState({});


    const [reportMaster, setReportMaster] = useState({});
    const [reportLoader, setReportLoader] = useState(true);
    const [repoStatus, setRepoStatus] = useState({});
    const [repoChanged, setRepoChanges] = useState({});



    const [pmtLoader, setPMTLoader] = useState(true);
    const [pmdDivData, setPMTDivData] = useState({});
    const [pmtGroupLoader, setPMTGroupLoader] = useState(true);
    const [pmtGroupData, setPMTGroupData] = useState({});
    const [pmtGroupStatus, setPMTGroupStatus] = useState({});
    const [pmtGroupChanged, setPMTGroupChanged] = useState({});
    const [selectedDivForPMT, setselectedDivForPMT] = useState(0);


    const [hqLoader, setHQLoader] = useState(true);
    const [hqDivData, setHQDivData] = useState({});  //div list of user for HQ
    const [hqBranchData, setHQBranchData] = useState({}); // Depo list of user for HQ
    const [hqTerData, setHQTeriData] = useState({});  // Terirtory data for user from server
    const [hqTeraStatus, setHQTeraStatus] = useState({}); // status list
    const [hqTeraChanged, setHQTeraChanged] = useState({}); //changed
    const [hqPermissionsLoader, setHQPermissionLoader] = useState(true);
    const [selectedDivForHQ, setSelectedDivForHQ] = useState(0);
    const [selectedBranchForHQ, setSelectedBranchForHQ] = useState(0);


    const handleDivisionChange = (key, val) => {
        const currentVal = divStatus[key];
        setDivStatus(prevStatus => ({
            ...prevStatus,
            [key]: currentVal === 'Y' ? 'N' : 'Y'
        }));

        setDivChanges(prevStatus => ({
            ...prevStatus,
            [key]: currentVal === 'Y' ? 'N' : 'Y'
        }));


    };

    const resetPMT = () => {
        setPMTGroupStatus({});
        setPMTGroupChanged({});
    }

    const resetTeritory = () => {
        setHQTeraChanged({});
        setHQTeraStatus({});
    }

    const resetDivision = () => {
        setDivChanges({});
        setDivStatus({});
    }

    const resetBranch = () => {
        setDepoChanges({});
        setDepoStatus({});
    }
    const handleRepoChange = (key) => {
        const currentVal = repoStatus[key];
        setRepoStatus(prevStatus => ({
            ...prevStatus,
            [key]: currentVal === 'Y' ? 'N' : 'Y'
        }));

        setRepoChanges(prevStatus => ({
            ...prevStatus,
            [key]: currentVal === 'Y' ? 'N' : 'Y'
        }));

        console.log(repoChanged);
    };


    const handleDepoChange = (key, val) => {
        const currentVal = hqTeraStatus[key];
        setHQTeraStatus(prevStatus => ({
            ...prevStatus,
            [key]: currentVal === 'Y' ? 'N' : 'Y'
        }));

        setHQTeraChanged(prevStatus => ({
            ...prevStatus,
            [key]: currentVal === 'Y' ? 'N' : 'Y'
        }));


    }

    const handlePMTChange = (key, val) => {
        const currentVal = pmtGroupStatus[key];
        setPMTGroupStatus(prevStatus => ({
            ...prevStatus,
            [key]: currentVal === 'Y' ? 'N' : 'Y'
        }));

        setPMTGroupChanged(prevStatus => ({
            ...prevStatus,
            [key]: currentVal === 'Y' ? 'N' : 'Y'
        }));

    }

    const handleBranchChange = (key, val) => {

        const currentVal = depoStatus[key];
        setDepoStatus(prevStatus => ({
            ...prevStatus,
            [key]: currentVal === 'Y' ? 'N' : 'Y'
        }));

        setDepoChanges(prevStatus => ({
            ...prevStatus,
            [key]: currentVal === 'Y' ? 'N' : 'Y'
        }));


    };


    const getDivPermissions = async () => {

        setShowProcessLoader(true);
        const divAPIResponse = await proxy(`/api/mis/userdivision/${uid}`, {}, "get");
        if (divAPIResponse.data) {
            setDivMaster(divAPIResponse);
            setDivLoader(false);
            const tempStatus = [];
            divAPIResponse.data.map(item => (
                tempStatus[item.id + '_' + item.val] = item.user_status
            ));

            setDivStatus(tempStatus);
        }
        setShowProcessLoader(false);
    }
    const getBranchPermissions = async () => {
        setShowProcessLoader(true);
        const divAPIResponse = await proxy(`/api/mis/userdepo/${uid}`, {}, "get");
        if (divAPIResponse.data) {
            setDepoMaster(divAPIResponse);
            setDepoLoader(false);
            const tempStatus = [];
            divAPIResponse.data.map(item => (
                tempStatus[item.id + '_' + item.val] = item.user_status
            ));

            setDepoStatus(tempStatus);

        }
        setShowProcessLoader(false);
    }

    const getReportPermissions = async () => {

        setReportLoader(true);
        setShowProcessLoader(true);
        const divAPIResponse = await proxy(`/api/mis/userreport/${uid}`, {}, "get");
        if (divAPIResponse.data) {
            setReportMaster(divAPIResponse);
            setReportLoader(false);
            const tempStatus = [];
            divAPIResponse.data.map(item => (
                item.menu_list.map(singleReport => (tempStatus[singleReport.repo_id + "_" + item.tab_id + "_" + singleReport.id] = singleReport.user_status))
            ));
            setRepoStatus(tempStatus);
            setRepoChanges({});

        }
        else {
            alert('Unable to load report permissions');
        }
        setShowProcessLoader(false);
        setReportLoader(false);
    }


    const handleDivSave = async () => {
        var permission_array = [];
        const hasDivChangedValues = Object.keys(divChanged).length > 0;

        if (hasDivChangedValues) {
            const transformedArray = Object.entries(divChanged).map(([key, user_status]) => {
                const [id, val] = key.split('_').map(Number);
                return {
                    id,
                    val,
                    user_id: parseInt(uid),
                    user_status
                };
            });

            const divAPIResponse = await proxy(`/api/mis/saveuserdivision`, transformedArray, "post");
            alert(divAPIResponse);
            resetDivision();
            getDivPermissions();

        } else {
            alert("No permission changed for divisions.")
        }

    }

    const handleReportSave = async () => {
        var permission_array = [];
        const hasDivChangedValues = Object.keys(repoChanged).length > 0;

        if (hasDivChangedValues) {
            const transformedArray = Object.entries(repoChanged).map(([key, user_status]) => {
                const [repo_id, tab_id, id] = key.split('_').map(String);
                return {
                    "repo_id": repo_id,
                    user_id: parseInt(uid),
                    user_status,
                    "tab_id": parseInt(tab_id),
                    "id": parseInt(id)

                };
            });

            const divAPIResponse = await proxy(`/api/mis/saveuserreport`, transformedArray, "post");
            alert(divAPIResponse);
            setRepoChanges({});


        } else {
            alert("No permission changed for reports.")
        }

    }



    const handleBranchSave = async () => {
        var permission_array = [];
        const hasDivChangedValues = Object.keys(depoChanged).length > 0;

        if (hasDivChangedValues) {
            const transformedArray = Object.entries(depoChanged).map(([key, user_status]) => {
                const [id, val] = key.split('_').map(Number);
                return {
                    id,
                    val,
                    user_id: parseInt(uid),
                    user_status
                };
            });

            const divAPIResponse = await proxy(`/api/mis/saveuserdepo`, transformedArray, "post");
            alert(divAPIResponse);
            resetBranch();
            getBranchPermissions();

        } else {
            alert("No permission changed for branches.")
        }

    }

    const handlePMTSave = async (pmt_id, pmt_val, user_statsyn, div_code) => {

      
         
     
        var permission_array = [];
        //const hasHQChangedValues = Object.keys(pmtGroupChanged).length > 0;

        const transformedArray = {
            "id": parseInt(pmt_id),
            "val": parseInt(pmt_val),
            "user_id": parseInt(uid),
            "user_status": user_statsyn,
            "div_code": parseInt(div_code),
        }
        const divAPIResponse = await proxy(`/api/mis/saveuserpmt`, transformedArray, "post");
    
        //alert(divAPIResponse);
        // resetPMT();
        //loadPMTGroupPermissions(selectedDivForPMT);

        // if (hasHQChangedValues) {
        //     const transformedArray = Object.entries(pmtGroupChanged).map(([key, user_status]) => {
        //         const [id, val] = key.split('_').map(Number);
        //         return {
        //             id,
        //             val,
        //             user_id: parseInt(uid),
        //             user_status,
        //             "div_code": parseInt(selectedDivForPMT),

        //         };
        //     });

        //     const divAPIResponse = await proxy(`/api/mis/saveuserpmt`, transformedArray, "post");
        //     alert(divAPIResponse);
        //     resetPMT();
        //     loadPMTGroupPermissions(selectedDivForPMT);

        // } else {
        //     alert("No permission changed for PMT.")
        // }
    }
    const handleHQSave = async () => {


        var permission_array = [];
        const hasHQChangedValues = Object.keys(hqTeraChanged).length > 0;

        if (hasHQChangedValues) {
            const transformedArray = Object.entries(hqTeraChanged).map(([key, user_status]) => {
                const [id, val] = key.split('_').map(Number);
                return {
                    id,
                    val,
                    user_id: parseInt(uid),
                    user_status,
                    "div_code": parseInt(selectedDivForHQ),
                    "depo_code": parseInt(selectedBranchForHQ)
                };
            });

            const divAPIResponse = await proxy(`/api/mis/saveuserter`, transformedArray, "post");
            alert(divAPIResponse);
            resetTeritory();
            getHQPermissions(selectedDivForHQ, selectedBranchForHQ);

        } else {
            alert("No permission changed for branches.")
        }


    }


    const getHQPermissions = async (div, depo) => {
        setHQPermissionLoader(true);
        const currentMYear = localStorage.getItem('selected_year');
        const HQAPIResponse = await proxy(`/api/mis/userter/${uid}/${currentMYear}/${div}/${depo}`, {}, "get");
        console.log(HQAPIResponse);
        if (HQAPIResponse.data) {
            const tempStatus = [];
            HQAPIResponse.data.map(item => (
                tempStatus[item.id + '_' + item.val] = item.user_status
            ));

            setHQTeraStatus(tempStatus);
            setHQTeriData(HQAPIResponse);
            setHQTeraChanged({});

        } else {
            alert('Unable to load HQ list');
        }

        setShowProcessLoader(false);
        setHQPermissionLoader(false);
    }

    const loadHQPermissions = async () => {
        setShowProcessLoader(true);
        setHQLoader(true);

        const divApiResponse = await proxy("/api/mis/userdivision/" + uid, {}, "get");
        const userDiv = divApiResponse.data
            .filter((div) => div.user_status === "Y")
            .map((div) => ({ value: div.val, name: div.name }));
        setHQDivData(userDiv);
        setSelectedDivForHQ(userDiv[0].value);


        const BranchApiResponse = await proxy("/api/mis/userdepo/" + uid, {}, "get");
        const userBranch = BranchApiResponse.data
            .filter((div) => div.user_status === "Y")
            .map((div) => ({ value: div.val, name: div.name }));
        setHQBranchData(userBranch);


        setHQLoader(false);
        getHQPermissions(userDiv[0].value, userBranch[0].value);
        setSelectedBranchForHQ(userBranch[0].value);


    }


    const loadPMTData = async () => {
        resetPMT();
        setShowProcessLoader(true);
        setPMTLoader(true);
        // const divApiResponse = await proxy("/api/mis/userdivision/" + uid, {}, "get");

        // const userDiv = divApiResponse.data
        //     .filter((div) => div.user_status === "Y")
        //     .map((div) => ({ value: div.val, name: div.name }));
        // setPMTDivData(userDiv);
        setPMTLoader(false);
        setShowProcessLoader(false);
        loadPMTGroupPermissions(0);
        setselectedDivForPMT(0);

    }



    const loadPMTGroupPermissions = async (DivID) => {

        setShowProcessLoader(true);
        setPMTGroupLoader(true);

        const grouplistAPIResponse = await proxy(`/api/mis/userpmt/${uid}`, {}, "get");
        console.log(grouplistAPIResponse);

        if (grouplistAPIResponse.data) {
            const tempStatus = [];
            grouplistAPIResponse.data.map(item => (
                tempStatus[item.gp_code + '_' + item.div_code] = item.user_status
            ));

            setPMTGroupStatus(tempStatus);
            setPMTGroupChanged({});
            setPMTGroupData(grouplistAPIResponse);

        } else {
            alert('Unable to load group list');
        }
        setPMTGroupLoader(false);
        setShowProcessLoader(false);
    }


    const handlePMTDivChange = (DivID) => {
        resetPMT();
        loadPMTGroupPermissions(DivID);


    }
    useEffect(() => {
        getDivPermissions();
        //  getBranchPermissions();
        // getReportPermissions();



    }, []);

    return (
        <>
            <div class="main-content">
                {showProcessLoader && <ProcessLoader />}
                <div className="row">
                    <div className="col-12">
                        <div className="card report-card" style={{ width: "min-content", minHeight: "calc( 100vh - 100px)" }}>
                            <div className="card-title report-card-title">Permissions
                                <button className="btn btn-outline btn-md  mr-10 fw-500" onClick={(e) => { window.location.href = "/settings-user-permissions-master" }}>BACK</button>
                            </div>


                            <div className="card-body card-body-multireport">
                                <h3 style={{ marginTop: "30px;", marginBottom: "30px" }}>#{uid} {name}</h3>


                                <ul class="nav nav-tabs nav-tabs-light-mode nav-justified" role="tablist">
                                    <li key="1" class="nav-item ">
                                        <a class={`nav-link active `} data-toggle="tab" href={`#tabdivision`} role="tab" onClick={() => { resetDivision(); getDivPermissions(); }}>Division</a>
                                    </li>
                                    <li key="2" class="nav-item ">
                                        <a class={`nav-link `} data-toggle="tab" href={`#tabbranch`} role="tab" onClick={() => {
                                            resetBranch();
                                            getBranchPermissions();
                                        }}>Branch</a>
                                    </li>
                                    <li key="3" class="nav-item ">
                                        <a class={`nav-link `} data-toggle="tab" href={`#tabeport`} role="tab" onClick={getReportPermissions}>Report</a>
                                    </li>
                                    {type == 3 && <><li key="4" class="nav-item ">
                                        <a class={`nav-link `} data-toggle="tab" href={`#tabpmt`} role="tab" onClick={loadPMTData}>PMT</a>
                                    </li></>}

                                    {type == 4 && <><li key="5" class="nav-item ">
                                        <a class={`nav-link `} data-toggle="tab" href={`#tabhq`} role="tab" onClick={loadHQPermissions}>HQ</a>
                                    </li></>}
                                </ul>

                                <div class="tab-content">

                                    <div key='1' className={`tab-pane fade active show`} id={`tabdivision`}>

                                        <h3 className="fs-16 fw-500">Division Permissions</h3>

                                        <div className="permissionContainer">
                                            {!divLoader &&
                                                <>
                                                    <ul className="list" style={{ listStyle: "none" }}>
                                                        {divMaster.data.map((divData, index) => (

                                                            <>
                                                                <li >
                                                                    <label class="switch switch-lg switch-info">


                                                                        <input type="checkbox"

                                                                            value={"Y"}
                                                                            checked={divStatus[divData.id + '_' + divData.val] == "Y" ? true : false}
                                                                            onChange={() => handleDivisionChange(divData.id + '_' + divData.val)}
                                                                            name={divData.id + '_' + divData.val} />
                                                                        <span class="switch-indicator"></span>
                                                                        <span class="switch-description">{divData.name}</span>
                                                                    </label>



                                                                </li>
                                                            </>
                                                        ))}
                                                    </ul>
                                                </>
                                            }

                                        </div>
                                        <button className="btn btn-sm btn-primary" onClick={handleDivSave} >Save Division Permissions</button>

                                    </div>
                                    <div key='2' className={`tab-pane fade`} id={`tabbranch`}>

                                        <h3 className="fs-16 fw-500">Branch Permissions</h3>

                                        <div className="permissionContainer">
                                            {!depoLoader &&
                                                <>
                                                    <ul className="list" style={{ listStyle: "none" }}>
                                                        {depoMaster.data.map((depoData, index) => (
                                                            <>
                                                                <li>
                                                                    <label class="switch switch-lg switch-info">
                                                                        <input
                                                                            value={"Y"}
                                                                            checked={depoStatus[depoData.id + '_' + depoData.val] == "Y" ? true : false}
                                                                            onChange={() => handleBranchChange(depoData.id + '_' + depoData.val)}
                                                                            type="checkbox" name={depoData.name} />
                                                                        <span class="switch-indicator"></span>
                                                                        <span class="switch-description">{depoData.name}</span>
                                                                    </label>
                                                                </li>
                                                            </>
                                                        ))}
                                                    </ul>
                                                </>
                                            }

                                        </div>
                                        <button className="btn btn-sm btn-primary" onClick={handleBranchSave} >Save Branch Permissions</button>

                                    </div>
                                    <div key='3' className={`tab-pane fade`} id={`tabeport`}>

                                        <h3 className="fs-16 fw-500">Report Permissions</h3>

                                        <div className="permissionContainer">
                                            {!reportLoader &&
                                                <>

                                                    {reportMaster.data.map((reportTab, index) => (
                                                        <>
                                                            <h3>{reportTab.tab_name}</h3>

                                                            <ul className="list" style={{ listStyle: "none" }}>
                                                                {reportTab.menu_list.map((reportData, indexInner) => (

                                                                    <li>
                                                                        <label class="switch switch-lg switch-info">
                                                                            <input type="checkbox" checked={repoStatus[reportData.repo_id + "_" + reportTab.tab_id + "_" + reportData.id] == "Y" ? true : false}
                                                                                onChange={() => handleRepoChange(reportData.repo_id + "_" + reportTab.tab_id + "_" + reportData.id)}
                                                                                name={reportData.repo_id}
                                                                            />
                                                                            <span class="switch-indicator"></span>
                                                                            <span class="switch-description">{reportData.repo_name}</span>
                                                                        </label>
                                                                    </li>



                                                                ))}

                                                            </ul>
                                                        </>
                                                    ))}

                                                </>
                                            }

                                        </div>


                                        <button className="btn btn-sm btn-primary" onClick={handleReportSave}  >Save Report Permissions</button>


                                    </div>

                                    {type == 3 && <>

                                        <div key='4' className={`tab-pane fade`} id={`tabpmt`}>

                                            <h3 className="fs-16 fw-500">PMT Permissions</h3>

                                            <div className="" >
                                                {!pmtLoader &&
                                                    <>


                                                        {!pmtGroupLoader &&
                                                            <>
                                                                <div className="" >
                                                                    <table className=" table table-striped " data-fixedHeader="true" cellspacing="0" id="reportDataTable" data-dom='plftrip' data-provide="datatables"  >
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Div Code</th>
                                                                                <th>Div Name</th>
                                                                                <th>Group Code</th>
                                                                                <th>Group Name</th>
                                                                                <th>Status</th>
                                                                                <th>Change Permission</th>
                                                                            </tr>

                                                                        </thead>
                                                                        <tbody>

                                                                            {pmtGroupData.data.map((depoData, index) => (
                                                                                <>
                                                                                    <tr>
                                                                                        <td>{depoData.div_code}</td>
                                                                                        <td>{depoData.div_name}</td>
                                                                                        <td>{depoData.gp_code}</td>
                                                                                        <td>{depoData.gp_name}</td>

<td>  {pmtGroupStatus[depoData.gp_code + '_' + depoData.div_code] == "Y" ? <span class="badge badge-success">Enabled</span> : <span class="badge badge-danger">Disabled</span> }</td>
                                                                                        <td>
                                                                                            {
                                                                                                pmtGroupStatus[depoData.gp_code + '_' + depoData.div_code] == "Y" ?
                                                                                                    <button className="btn btn-danger btn-outline btn-sm" onClick={() => {   if( window.confirm("You sure you want to change permission?")){handlePMTChange(depoData.gp_code + '_' + depoData.div_code); handlePMTSave(depoData.id, depoData.gp_code, "N", depoData.div_code) }}}>Disable</button>
                                                                                                    :
                                                                                                    <button className="btn btn-success btn-outline btn-sm" onClick={() => {   if( window.confirm("You sure you want to change permission?")){ handlePMTChange(depoData.gp_code + '_' + depoData.div_code); handlePMTSave(depoData.id, depoData.gp_code, "Y", depoData.div_code);} }}>Enable</button>
                                                                                            } &nbsp;


                                                                                            {/* <label class="switch switch-lg switch-info">
                                                                                    <input
                                                                                        value={"Y"}
                                                                                        checked={pmtGroupStatus[depoData.id + '_' + depoData.val] == "Y" ? true : false}
                                                                                        onChange={() => handlePMTChange(depoData.id + '_' + depoData.val)}
                                                                                        type="checkbox"
                                                                                        key={depoData.id + '_' + depoData.val}
                                                                                        id={depoData.id + '_' + depoData.val}
                                                                                        name={depoData.name} />
                                                                                    <span class="switch-indicator"></span>
                                                                                    <span class="switch-description">{depoData.name}</span>
                                                                                </label> */}
                                                                                        </td>

                                                                                    </tr>
                                                                                </>
                                                                            ))}

                                                                        </tbody>

                                                                    </table></div>


                                                            </>
                                                        }


                                                    </>
                                                }

                                            </div>





                                        </div>


                                    </>}

                                    {type == 4 && <>

                                        <div key='5' className={`tab-pane fade`} id={`tabhq`}>

                                            <h3 className="fs-16 fw-500">HQ Permissions</h3>

                                            <div className="permissionContainer" >
                                                {!hqLoader &&
                                                    <>
                                                        <div style={{ width: "300px" }}>

                                                            Division<DropDownControl

                                                                onChange={(newVal) => { console.log(newVal); getHQPermissions(newVal, selectedBranchForHQ); setSelectedDivForHQ(newVal) }}
                                                                selectedValue={1} data={hqDivData} id="report_div_list" name="report_div_list" />

                                                            Branch<DropDownControl onChange={(newVal) => { console.log(newVal); getHQPermissions(selectedDivForHQ, newVal); setSelectedBranchForHQ(newVal) }}
                                                                selectedValue={1} data={hqBranchData} id="report_depo_list" name="report_depo_list" />
                                                            <br />
                                                            <br />
                                                        </div>

                                                        {!hqPermissionsLoader &&
                                                            <>
                                                                <ul className="list" style={{ listStyle: "none" }}>
                                                                    {hqTerData.data.map((depoData, index) => (
                                                                        <>
                                                                            <li>
                                                                                <label class="switch switch-lg switch-info">
                                                                                    <input
                                                                                        value={"Y"}
                                                                                        checked={hqTeraStatus[depoData.id + '_' + depoData.val] == "Y" ? true : false}
                                                                                        onChange={() => handleDepoChange(depoData.id + '_' + depoData.val)}
                                                                                        type="checkbox"
                                                                                        id={depoData.id + '_' + depoData.val}
                                                                                        name={depoData.name} />
                                                                                    <span class="switch-indicator"></span>
                                                                                    <span class="switch-description">{depoData.name}</span>
                                                                                </label>
                                                                            </li>
                                                                        </>
                                                                    ))}
                                                                </ul>
                                                            </>
                                                        }
                                                    </>
                                                }

                                            </div>


                                            <button className="btn btn-sm btn-primary" onClick={handleHQSave}  >Save HQ Permissions</button>


                                        </div>


                                    </>}




                                </div>

                            </div>

                        </div></div></div>



            </div>
        </>
    );
}

export default UserPermissions;